/**
 * @ngInject
 */
function SendDialogCtrl($scope, $mdDialog, $location, $auth, userStore, flux, actions){
	var ctrl = this;
    ctrl.user = userStore.getUser();
    if(_.size(ctrl.user) < 13) {
        ctrl.state = 'not-done';
    } else {
        ctrl.state = 'done';
    }

	
	ctrl.hide = function() {
		$mdDialog.hide();
	};
	ctrl.cancel = function() {
      $mdDialog.cancel();
    };
}